// @flow
import React from 'react';

import { createFragmentContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import toTranslit from '../../util/cyrillic-to-translit';
// material.ui reafctoring
import { option } from 'fp-ts';
import toast from 'react-hot-toast';
import TextField from 'material-ui/TextField';
import Paper from 'material-ui/Paper';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import { Tabs, Tab } from 'material-ui/Tabs';
import Toggle from 'material-ui/Toggle';
import Checkbox from 'material-ui/Checkbox';
import Subheader from 'material-ui/Subheader';
import RaisedButton from 'material-ui/RaisedButton';
// draft-js
import { convertToRaw } from 'draft-js';
import IconButton from 'material-ui/IconButton';
import IconRemove from 'material-ui/svg-icons/navigation/close';
import 'medium-draft/lib/index.css';
// editor
import DraftEditor from '../editor/draft/DraftEditor';
// Мониторинг редактирования статьи
import ReportEditing from '../reportEditing/ReportEditing';
// mutation
import * as ArticleAddMutation from '../../mutations/ArticleAddMutation';
import * as ArticleEditMutation from '../../mutations/ArticleEditMutation';
import * as ArticleDeleteMutation from '../../mutations/ArticleDeleteMutation';

import TopicSelector from '../TopicSelector';
import ArticleSelector from './ArticleSelector';
// editor
import mediumDraftExporter from '../editor/exporter';
import LastEdit from '../lastEdit/LastEdit';
// upload mediafiles info
import updateMediaFiles from '../media/updateMediaFile';
// Список авторов
import AuthorList from '../author/AuthorList';
// Char counter
import TextCharCount from '../ui/charCounter';

import { preserveDate } from '../../lib/DateUtils';

import { DefaultButton } from '../controls/button';
import SectionSelector from '../SectionSelector';
// Snippet
import ArticleSnippet from './ArticleSnippet';
// style
import '../editor/sideButtons.css';
import '../ui/button.css';
import '../ui/article.css';
import { styles, paperStyle, formElement } from '../../lib/styles';
import { backendUrl, sectionPath } from '../../lib/config';
import modernEnvironment from '../../lib/RelayUtils';
import { CombinedPreviewVideo } from './components/CombinedPreviewVideo';
import { ArticlePreview } from './components/ArticlePreview';
import { ArticlePreviewTab } from './components/ArticlePreviewTab';
import { pipe } from 'fp-ts/lib/pipeable';
import { Snackbar } from 'material-ui';
import { fold, none, Option, some } from 'fp-ts/lib/Option';
import { titleValidation } from '../../util/validation';
import buttonStyle from '../ui/button';
import { Alert } from '@material-ui/lab';
import { withAppContext } from '../../AppContext';
import ArticleSpellCheckStatusSection from './ArticleSpellCheckStatusSection';
import type { SpellCheckStatusProp, SpellCheckResultProp } from './ArticleSpellCheckStatusSection';
import ArticleBodyFactCheckingLink from './ArticleBodyFactCheckingLink';
import './articleSpellCheckStatusFields';
import { fetchQueryWithTimeout } from '../../lib/fetchQueryWithTimeout';

const spellCheckQuery = graphql`
	query ArticleSpellCheckQuery($id: ID!, $text: String!) {
		spellCheck(id: $id, text: $text) {
			rawAnswer
			factChecking
		}
	}
`;

const spellCheckStatusRefetchQuery = graphql`
	query ArticleSpellCheckStatusRefetchQuery($id: ID!) {
		spellCheckStatus(id: $id) {
			...articleSpellCheckStatusFields @relay(mask: false)
		}
	}
`;

const SPELL_CHECK_TIMEOUT_MS = 300 * 1000;
const SPELL_CHECK_STATUS_TIMEOUT_MS = 30 * 1000;

type Props = {
	viewer: Object,
	match: Object,
	history: Object,
	location: Object,
	relay: Object,
	spellCheckStatus: SpellCheckStatusProp,
};

type State = {
	author: string,
	availableAt: ?Date,
	buttonDisableState: boolean,
	category: ?string,
	yaGenre: ?string,
	changes: Array<any>,
	editorState: ?Object,
	edit: boolean,
	isArticleOfDay: boolean,
	isEvent: boolean,
	isMainNews: boolean,
	snackbarMessage: Option<string>,
	lead: string,
	linkedArticles: Array<?{ id: string, title: string }>,
	mainPageOrder: number,
	preview: { id?: string, filename?: string, description?: string },
	combinedPreviewVideo: { id?: string, filename?: string, description?: string },
	previewAttribution: ?string,
	previewPicture: ?string,
	section: string,
	seoDescription: ?string,
	seoKeywords: string,
	seoTitle: string,
	showInYandexNews: boolean,
	showInYandexZen: boolean,
	infostring: boolean,
	infostring_hot: boolean,
	slug: string,
	slugChanged: boolean,
	state: string,
	title: string,
	topics: Array<?{ id?: string, name?: string }>,
	updateEditor: boolean,
	spellCheckResult: SpellCheckResultProp,
	spellCheckLoading: boolean,
	activeTabValue: string,
	spellCheckRequiredForPublish: boolean,
	skipSpellCheckForPublish: boolean,
	spellCheckStatusOverride?: SpellCheckStatusProp,
};

const maxLengthLead = 400;

class Article extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		const { article } = this.props.viewer;
		const es = article === null ? null : JSON.parse(article.body);
		const isArticle = article !== null;

		let isMainNews = undefined;
		const configurableBlock = this.props.viewer.configurableBlock;
		if (configurableBlock !== null) {
			const { config, type } = configurableBlock;
			if (type === 'listNews') {
				const { original = [] } = config;
				const ids = original.map(item => item.id);
				isMainNews = !!(isArticle && ids.includes(article.id)) || undefined;
			} else {
				isMainNews = !!(isArticle && article.id === config.article.id) || undefined;
			}
		}

		const section = isArticle ? article.section : this.props.match.params.section;
		const showInYandexNews =
			isArticle && article.showInYandexNews !== null
				? article.showInYandexNews
				: section === sectionPath.news;

		this.state = {
			// открыть медагалерею
			isMainNews,
			buttonDisableState: false,
			slugChanged: false,
			snackbarMessage: none,
			foreignAgent: isArticle ? article.foreignAgent : false,
			slug: isArticle ? article.slug : '',
			changes: isArticle ? article.changes : [],
			seoTitle: isArticle ? article.seoTitle : '',
			seoDescription: isArticle ? article.seoDescription : '',
			seoKeywords: isArticle ? article.seoKeywords : '',
			availableAt: isArticle && article.availableAt !== null ? new Date(article.availableAt) : null,
			author: isArticle && article.author !== null ? article.author : this.props.viewer.me.id,
			combinedPreviewVideo: isArticle && article.combinedPreviewVideo !== null ? article.combinedPreviewVideo : null,
			preview: isArticle && article.preview !== null ? article.preview : null,
			previewPicture: isArticle && article.previewPicture !== null ? article.previewPicture : null,
			previewAttribution: isArticle && article.previewAttribution !== null ? article.previewAttribution : null,
			isEvent: isArticle && article.isEvent !== null ? article.isEvent : false,
			infostring: isArticle && article.infostring !== null ? article.infostring : false,
			infostring_hot: isArticle && article.infostring_hot !== null ? article.infostring_hot : false,
			showInYandexNews,
			showInYandexZen: isArticle && article.showInYandexZen !== null ? article.showInYandexZen : false,
			title: isArticle ? article.title : '',
			yaGenre: isArticle ? article.yaGenre : '',
			section,
			category: isArticle ? article.category : null,
			topics: article && article.topics ? article.topics : [],
			lead: isArticle && article.lead !== null ? article.lead : '',
			linkedArticles: article && article.linkedArticles ? article.linkedArticles : [],
			editorState: es,
			updateEditor: false,
			state: isArticle ? article.state : 'draft',
			edit: false,
			mainPageOrder: isArticle ? article.mainPageOrder : 0,
			spellCheckResult: null,
			spellCheckLoading: false,
			activeTabValue: 'main',
			spellCheckRequiredForPublish: false,
			skipSpellCheckForPublish: false,
		};
	}

	componentDidUpdate(prevProps: Props) {
		const prevId = prevProps.viewer.article != null ? prevProps.viewer.article.id : null;
		const nextId = this.props.viewer.article != null ? this.props.viewer.article.id : null;
		if (prevId !== nextId) {
			this.setState({ spellCheckStatusOverride: undefined });
		}
	}

	runSpellCheck = () => {
		const { editorState, title, lead } = this.state;
		const bodyText =
			editorState && editorState.getCurrentContent
				? editorState.getCurrentContent().getPlainText()
				: '';
		const text = [(title || '').trim(), (lead || '').trim(), bodyText].join('\n');
		if (!text.trim()) {
			toast.error('Нет текста для проверки');
			return;
		}
		const articleId = this.props.viewer.article != null ? this.props.viewer.article.id : null;
		if (articleId == null || articleId === '') {
			toast.error('Не удалось определить id статьи');
			return;
		}
		this.setState({ spellCheckLoading: true, spellCheckResult: null });
		fetchQueryWithTimeout(
			modernEnvironment,
			spellCheckQuery,
			{ id: articleId, text },
			SPELL_CHECK_TIMEOUT_MS,
			'Превышено время ожидания проверки орфографии',
		)
			.then(response => {
				const spellCheck = response != null ? response.spellCheck : null;
				if (spellCheck == null || typeof spellCheck.rawAnswer !== 'string' || spellCheck.rawAnswer.trim() === '') {
					throw new Error('Пустой ответ сервера');
				}
				this.setState({
					spellCheckLoading: false,
					spellCheckResult: {
						rawAnswer: spellCheck.rawAnswer,
						factChecking:
							spellCheck.factChecking != null && spellCheck.factChecking.trim() !== ''
								? spellCheck.factChecking
								: null,
					},
					spellCheckRequiredForPublish: false,
					skipSpellCheckForPublish: false,
				});
				toast.success('Проверка завершена');
				fetchQueryWithTimeout(
					modernEnvironment,
					spellCheckStatusRefetchQuery,
					{ id: articleId },
					SPELL_CHECK_STATUS_TIMEOUT_MS,
					'Превышено время ожидания статуса проверки',
				)
					.then(statusResponse => {
						if (statusResponse == null || !{}.hasOwnProperty.call(statusResponse, 'spellCheckStatus')) {
							return;
						}
						this.setState({
							spellCheckStatusOverride: statusResponse.spellCheckStatus,
						});
					})
					.catch(() => {
						// статус вторичен: проверка уже прошла успешно
					});
			})
			.catch(err => {
				this.setState({ spellCheckLoading: false });
				toast.error('Ошибка проверки: ' + (err.message || 'неизвестная ошибка'));
			});
	};

	onTitleChanged = (newValue: string) => {
		if (this.state.slugChanged || this.props.viewer.article) {
			this.setState({ title: newValue });
		} else {
			this.setState({
				title: newValue,
				slug: toTranslit(newValue),
			});
		}
	};

	onSlugChanged = (newValue: string) => {
		this.setState({
			slugChanged: true,
			slug: newValue,
		});
	};

	handleCloseSnackbar = () => {
		this.setState({
			snackbarMessage: none,
		});
	};

	onStateChanged = (articleState: string) => {
		const prevState = this.state.state;

		if (articleState === 'available' && (this.state.availableAt === null || this.state.availableAt === undefined)) {
			console.log('setting state with avail date');
			this.setState({
				state: this.state.state === 'available' ? 'draft' : this.state.state,
				availableAt: new Date(),
				spellCheckRequiredForPublish: false,
				skipSpellCheckForPublish: false,
			});
		} else {
			console.log('setting state without avail date');
			const nextState = articleState;
			const spellCheckExist = !this.props.spellCheckStatus;
			if (prevState === 'draft' && nextState === 'available') {
				this.setState({
					state: nextState,
					spellCheckRequiredForPublish: spellCheckExist,
					spellCheckResult: null,
					skipSpellCheckForPublish: false,
				});
			} else if (nextState !== 'available') {
				this.setState({
					state: nextState,
					spellCheckRequiredForPublish: false,
					skipSpellCheckForPublish: false,
				});
			} else {
				this.setState({ state: nextState });
			}
		}
	};

	onOrderChanged = (event, index, value) => {
		this.setState({ mainPageOrder: parseInt(value, 10) });
	};

	getMediaFiles = body => {
		const raw = JSON.parse(body);
		if (!{}.hasOwnProperty.call(raw, 'entityMap')) {
			return [];
		}
		const entity = raw.entityMap;
		const mediaFilesId = [];
		Object.keys(entity).forEach(key => {
			if ({}.hasOwnProperty.call(entity, key)) {
				if (entity[key].type === 'video') {
					mediaFilesId.push(entity[key].data.id);
				}
			}
		});
		return mediaFilesId;
	};

	/**
	 * Получение новой информации по истории изменений.
	 */
	getChangesHistory = () => {
		const query = `query Article_Query($id: ID!){
          viewer{
            article(id: $id) {
              changes{
                userId,
                userName,
                modDate
              }
            }
          }
        }`;
		const variables = { id: this.props.viewer.article.id };
		fetch(`${backendUrl}/graphql`, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				query,
				variables,
			}),
		})
			.then(response => response.json())
			.then(response => {
				if ({}.hasOwnProperty.call(response, 'data')) {
					if (response.data && response.data.viewer) {
						this.setState({ changes: response.data.viewer.article.changes });
						return null;
					}
					return null;
				}
				return null;
			});
	};

	remove = () => {
		const callback = (error: ?Error, articleId: ?string) => {
			this.setState({ buttonDisableState: false });
			if (error === 'already_changed') {
				toast.error('Материал был изменён кем-то ещё. Сохраните работу, перезагрузите страницу и попробуйте снова.');
				return;
			}

			if (error != null) {
				toast.error('error saving article');
				return;
			}

			if (articleId && !this.props.viewer.article) {
				this.props.history.replace(`/articles/${this.state.section}/${articleId}`);
			} else {
				this.getChangesHistory();
			}
		};
		const article = this.props.viewer.article;
		if (article !== null) {
			const params = {
				id: article.id,
			};
			ArticleDeleteMutation.commit(this.props.relay.environment, params, callback);
			window.location = '/articles';
		}
	};

	save = () => {
		const callback = (error: ?Error, articleId: ?string) => {
			this.setState({ buttonDisableState: false });
			if (error === 'not_uniq_slug') {
				toast.error('Уже имеется материал с таким слагом')
				return;
			}
			if (error === 'already_changed') {
				toast.error('Материал был изменён кем-то ещё. Сохраните работу, перезагрузите страницу и попробуйте снова.');
				return;
			}

			if (error != null) {
				toast.error('Ошибка сохранения статьи');
				return;
			}
			if (articleId) {
				this.props.history.replace(`/articles/${this.state.section}/${articleId}`);
			}
		};

		const { lead, category, author, preview, combinedPreviewVideo } = this.state;

		let { title } = this.state;

		title = title.trim();
		title = title.replace(/\s{2,}/g, ' ');

		if (!title.length || !lead.length || category === null) {
			return;
		}

		if (combinedPreviewVideo !== null && preview === null) {
			this.setState({
				snackbarMessage: some('Необходимо установить фото для превью'),
			});
			return;
		}

		if (this.state.infostring && titleValidation(this.state.title) !== null) {
			this.setState({
				snackbarMessage: some('Для выгрузки в бегущую строку сократите заголовок!'),
			});
			return;
		}

		// Определяем, текущий автор статьи есть в списке авторов.
		const flagSelectedAuthor = this.props.viewer.persons.edges.some(item => author === item.node.id);
		let articleState = this.state.state;

		if (!flagSelectedAuthor || author === this.props.viewer.me.id) {
			this.setState({
				state: this.state.state === 'available' ? 'draft' : this.state.state,
			});
			articleState = this.state.state === 'available' ? 'draft' : this.state.state;
		}
		const { categories } = this.props.viewer;

		// соответствие кодов для рекламы адфокса категориям
		const puid8 = {
			Политика: '&puid8=190000',
			Экономика: '&puid8=190001',
			Мир: '&puid8=190002',
			Страна: '&puid8=190003',
			Общество: '&puid8=190004',
			Происшествия: '&puid8=190005',
			Армия: '&puid8=190006',
			Культура: '&puid8=190007',
			Стиль: '&puid8=190008',
			Авто: '&puid8=190009',
			Наука: '&puid8=190010',
			Спорт: '&puid8=190011',
			Интернет: '&puid8=190012',
			Туризм: '&puid8=190013',
			Недвижимость: '&puid8=190014',
			Спецпроекты: '&puid8=190015',
			Здоровье: '&puid8=190016',
		};
		const { state } = this;
		// соотносим передаваемый globalID категории с кодом из списка puid8 и возвращаем патч для url
		const getCategoryPuid = cat => {
			let puid = '';
			categories.edges.forEach(e => {
				if (e.node.id === cat) {
					puid = puid8[e.node.name];
				}
			});
			return puid;
		};

		const baseParams = {
			title,
			lead: state.lead.replace('\u0003', ''),
			topics: state.topics.map(topic => topic.id),
			// preview: state.preview && state.preview.hasOwnProperty('id') ? state.preview.id : '',
			preview: state.preview && {}.hasOwnProperty.call(state.preview, 'id') ? state.preview.id : '',
			combinedPreviewVideo:
				state.combinedPreviewVideo && {}.hasOwnProperty.call(state.combinedPreviewVideo, 'id') ? state.combinedPreviewVideo.id : '',
			previewAttribution: state.previewAttribution,
			isEvent: state.isEvent,
			isMainNews: state.isMainNews,
			infostring: state.infostring,
			infostring_hot: state.infostring_hot,
			showInYandexNews: state.showInYandexNews,
			showInYandexZen: state.showInYandexZen,
			section: state.section,
			yaGenre: state.yaGenre,
			category: state.category,
			author: state.author,
			previewPicture: state.previewPicture,
			body: JSON.stringify(convertToRaw(state.editorState.getCurrentContent())),
			bodyHtml: mediumDraftExporter(state.editorState.getCurrentContent(), getCategoryPuid(state.category)),
			availableAt: state.availableAt || new Date(),
			linkedArticles: state.linkedArticles.map(a => a.id),
			seoTitle: state.seoTitle,
			seoDescription: state.seoDescription,
			seoKeywords: state.seoKeywords,
			state: articleState,
			mediaFiles: [],
			mainPageOrder: state.mainPageOrder,
		};

		const { viewer, appContext } = this.props;

		const { article } = viewer;

		if(article && appContext.isAdmin && state.slug !== article.slug) {
			baseParams.slug = state.slug;
		}

		if (baseParams.lead === '') {
			return;
		}
		const mediaFilesId = this.getMediaFiles(baseParams.body);
		// обновляем информацию у медиа-файлов
		if (mediaFilesId.length) {
			const updateDataForMediaFile = {
				title,
				description: state.lead,
				topics: state.topics,
				slug: state.slug,
			};
			baseParams.mediaFiles = mediaFilesId;
			mediaFilesId.forEach(mediaId => updateMediaFiles(mediaId, updateDataForMediaFile));
		}

		this.setState({ buttonDisableState: true });

		if (article !== null) {
			const params = {
				id: article.id,
				changesCount: state.changes ? state.changes.length : undefined,
				...baseParams,
			};
			ArticleEditMutation.commit(this.props.relay.environment, params, callback);
		} else {
			const params = {
				slug: this.state.slug,
				...baseParams,
			};
			ArticleAddMutation.commit(this.props.relay.environment, params, callback);
		}
	};

	handleCombinedPreviewChange = file => {
		const { preview } = this.state;
		const combinedPreviewVideo = pipe(
			file,
			option.map(file => ({
				id: file.id,
				filename: file.filename,
			})),
			option.getOrElse(() => null),
		);

		this.setState({
			combinedPreviewVideo,
		});
	};

	handleArticlePreviewChange = file => {
		const newState = this.getNewPreview(file);
		this.setState({
			preview: newState.preview,
			previewPicture: newState.previewPicture,
			previewAttribution: newState.previewAttribution,
		});
	};

	getNewPreview = file => {
		const newState = pipe(
			file,
			option.map(file => ({
				preview: {
					id: file.id,
					filename: file.filename,
				},
				previewAttribution: file.previewAttribution,
			})),
			option.getOrElse(() => ({
				preview: null,
				previewPicture: '',
				previewAttribution: '',
			})),
		);

		return {
			preview: newState.preview,
			previewPicture: newState.previewPicture,
			previewAttribution: newState.previewAttribution,
		};
	};

	changeAuthor = (newAuthor: { name: string, id: string }) => {
		this.setState({ author: newAuthor.id });
	};

	reloadPage = () => {
		window.location = window.location;
	};

	render() {
		const { viewer, appContext } = this.props;

		const { categories, persons } = viewer;

		const { category, editorState, mainPageOrder, isMainNews } = this.state;
		const isSlugDisabled = appContext.isAdmin ? false : Boolean(viewer.article);

		return (
			<div style={{ display: 'flex' }}>
				{pipe(
					this.state.snackbarMessage,
					fold(
						() => null,
						message => (
							<Snackbar
								open={true}
								message={message}
								bodyStyle={{
									backgroundColor: '#ef426f',
								}}
								autoHideDuration={2000}
								onRequestClose={this.handleCloseSnackbar}
							/>
						),
					),
				)}
				<Paper style={paperStyle.mainItem} id="material-wrapper">
					{viewer.article && (
						<ReportEditing
							entityId={viewer.article.id}
							userName={viewer.me.name}
							relay={this.props.relay}
							hasEditor={flag => {
								this.setState({
									edit: flag,
									buttonDisableState: flag,
								});
							}}
							reloadPage={this.reloadPage}
							parent="material-wrapper"
						/>
					)}
					<Tabs
						value={this.state.activeTabValue}
						onChange={(value) => this.setState({ activeTabValue: value })}
						tabItemContainerStyle={{
							background: 'white',
							marginTop: '16px',
						}}
						inkBarStyle={{ background: '#542376' }}
					>
						<Tab value='main' label="Материал" style={{ color: 'black', fontWeight: '500' }}>
							<TextField
								hintText="Введите заголовок"
								floatingLabelText="Заголовок"
								style={formElement.textField}
								value={this.state.title}
								maxLength="90"
								fullWidth
								errorText={titleValidation(this.state.title)}
								onChange={(event, value) => {
									this.onTitleChanged(value);
								}}
								floatingLabelFixed
								disabled={this.state.edit}
							/>
							<TextCharCount maxChar={90} currentChar={this.state.title.length} />

							<TextField
								hintText="Ссылка"
								floatingLabelText="Ссылка"
								value={this.state.slug || ''}
								maxLength="90"
								fullWidth
								disabled={isSlugDisabled}
								errorText={this.state.title === null || this.state.title.length === 0 ? 'это поле нужно заполнить' : null}
								onChange={(event, value) => {
									this.onSlugChanged(value);
								}}
								floatingLabelFixed
							/>

							<TextField
								hintText="Введите лид"
								floatingLabelText="Лид"
								style={formElement.textField}
								value={this.state.lead}
								fullWidth
								multiLine
								rows={2}
								rowsMax={4}
								maxLength={maxLengthLead}
								minLength="150"
								errorText={this.state.lead === null || this.state.lead.length === 0 ? 'это поле нужно заполнить' : null}
								onChange={(event: any, newValue: string) => this.setState({ lead: newValue })}
								floatingLabelFixed
								disabled={this.state.edit}
							/>

							<TextCharCount maxChar={maxLengthLead} currentChar={this.state.lead.length} />

							<ArticlePreview
								preview={this.state.preview}
								previewPicture={this.state.previewPicture}
								previewAttribution={this.state.previewAttribution}
								onValueChange={this.handleArticlePreviewChange}
							/>
							<CombinedPreviewVideo
								preview={this.state.combinedPreviewVideo}
								edit={this.state.edit}
								onValueChange={this.handleCombinedPreviewChange}
							/>

							<div
								style={{
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'space-between',
									marginTop: 16,
									marginBottom: 8,
								}}
							>
								<span style={{ fontSize: 12, color: 'rgba(0, 0, 0, 0.3)' }}>Текст материала</span>
								<ArticleBodyFactCheckingLink
									factChecking={
										this.state.spellCheckResult != null
											? this.state.spellCheckResult.factChecking
											: null
									}
								/>
							</div>
							<DraftEditor
								onChange={e => this.setState({ editorState: e })}
								state={editorState}
								update={this.state.updateEditor}
								location={{
									insertItem: this.props.location.insertItem,
								}}
								readOnly={this.state.edit}
							/>
						</Tab>

						<Tab value='spellCheck' label="Орфография" style={{ color: 'black', fontWeight: '500' }}>
							<ArticleSpellCheckStatusSection
								status={
									this.state.spellCheckStatusOverride !== undefined
										? this.state.spellCheckStatusOverride
										: this.props.spellCheckStatus
								}
								spellCheckLoading={this.state.spellCheckLoading}
								spellCheckResult={this.state.spellCheckResult}
							/>
						</Tab>

						<Tab value='info' label="Информация" style={{ color: 'black', fontWeight: '500' }}>
							<div style={{ display: 'flex' }}>
								<DatePicker
									autoOk
									disabled={this.state.state !== 'available'}
									floatingLabelText="C (дата)"
									onChange={(e, d) =>
										this.setState({
											availableAt: preserveDate(this.state.availableAt, d),
										})
									}
									value={this.state.availableAt}
									style={{ marginRight: '16px' }}
								/>

								<TimePicker
									autoOk
									format="24hr"
									disabled={this.state.state !== 'available'}
									floatingLabelText="C (время)"
									onChange={(e, d) =>
										this.setState({
											availableAt: preserveDate(this.state.availableAt, d),
										})
									}
									value={this.state.availableAt}
								/>
							</div>
							<section className="article--info">
								<div className="article--info-column">
									{this.state.changes.length > 0 && <LastEdit changes={this.state.changes} />}

									<AuthorList author={this.state.author} list={persons.edges} onChange={this.changeAuthor} />

									<Subheader>Главные новости</Subheader>

									<div className="article-config-column">
										<Toggle
											toggled={isMainNews}
											label="Главная новость"
											onToggle={(e, v) => this.setState({ isMainNews: v })}
											disabled={this.state.edit}
										/>
										<div className="article--order">
											<label title="4 новости вывводимые на главной странице">Показ на главной</label>
											<SelectField autoWidth value={mainPageOrder} onChange={this.onOrderChanged} disabled={this.state.edit}>
												{Array.from({ length: 5 }, (v, i) => i).map(v => (
													<MenuItem value={v} primaryText={v.toString()} />
												))}
											</SelectField>
											{typeof mainPageOrder !== 'undefined' ? (
												<IconButton style={buttonStyle.smallIcon} onClick={() => this.setState({ mainPageOrder: undefined })}>
													<IconRemove />
												</IconButton>
											) : null}
										</div>
										<Toggle
											toggled={this.state.isEvent}
											label="Показывать в сайдбаре"
											onToggle={(e, v) => this.setState({ isEvent: v })}
											disabled={this.state.edit}
										/>
									</div>

									<Subheader>Дзен</Subheader>
									<div className="article-config-column">
										<Toggle
											toggled={this.state.showInYandexNews}
											label="Дзен новостой фид и сюжеты"
											onToggle={(e, v) => this.setState({ showInYandexNews: v })}
											disabled={this.state.edit}
										/>

										<Toggle
											toggled={this.state.showInYandexZen}
											label="Не отправлять в сюжеты"
											onToggle={(e, v) => this.setState({ showInYandexZen: v })}
											disabled={this.state.edit}
										/>
									</div>

									<Subheader>Бегущая строка</Subheader>
									<div className="article-config-column">
										<Toggle
											toggled={this.state.infostring}
											label="Отображать в бегущей строке"
											onToggle={(e, v) => {
												const updatedState = { infostring: v };
												if (!v) {
													updatedState.infostring_hot = false;
												}
												this.setState(updatedState);
											}}
											disabled={this.state.edit}
										/>

										<Toggle
											toggled={this.state.infostring_hot}
											label="Горячая новость"
											onToggle={(e, v) => {
												const updatedState = { infostring_hot: v };
												if (v) {
													updatedState.infostring = true;
												}
												this.setState(updatedState);
											}}
											disabled={this.state.edit}
										/>
									</div>
								</div>
								<div className="article--info-column">
									<div className="article--info-selector">
										<small style={{ ...formElement.small, display: 'block', marginTop: 19 }}>Связанные новости</small>
										<ArticleSelector
											viewer={this.props.viewer}
											value={this.state.linkedArticles}
											onChange={v => this.setState({ linkedArticles: v })}
											disabled={this.state.edit}
										/>
									</div>
								</div>
							</section>
						</Tab>

						<Tab value='meta' label="Мета" style={{ color: 'black', fontWeight: '500' }}>
							<TextField
								hintText="SEO title"
								floatingLabelText="SEO title"
								style={formElement.textField}
								value={this.state.seoTitle}
								maxLength="70"
								fullWidth
								onChange={(e, v) => this.setState({ seoTitle: v })}
								floatingLabelFixed
								disabled={this.state.edit}
							/>

							<TextField
								hintText="SEO description"
								floatingLabelText="SEO description"
								style={formElement.textField}
								value={this.state.seoDescription}
								fullWidth
								multiLine
								rows={2}
								rowsMax={4}
								onChange={(e, v) => this.setState({ seoDescription: v })}
								floatingLabelFixed
								disabled={this.state.edit}
							/>

							<TextField
								hintText="SEO keywords"
								floatingLabelText="SEO keywords"
								style={formElement.textField}
								value={this.state.seoKeywords || ''}
								fullWidth
								onChange={(e, v) => this.setState({ seoKeywords: v })}
								floatingLabelFixed
								disabled={this.state.edit}
							/>

							<ArticleSnippet
								seoTitle={this.state.seoTitle || ''}
								seoKeywords={this.state.seoKeywords || ''}
								seoDescription={this.state.seoDescription || ''}
							/>
						</Tab>
						{this.props.viewer.article && (
							<Tab value='preview' label="Превью" style={{ color: 'black', fontWeight: '500' }}>
								<ArticlePreviewTab
									availableAt={this.state.availableAt}
									slug={this.state.slug}
								/>
							</Tab>
						)}
					</Tabs>
				</Paper>

				<div style={{ ...styles.sidebar.default, marginTop: 0 }}>
					<div style={{ width: 267 }}>
						{this.state.foreignAgent ? (
							<Alert variant="filled" color="error">
								Внимание! В тексте присутствуют фамилии иноагентов. Пожалуйста, проверьте маркировку, если такие имеются.
							</Alert>
						) : null}
						<SectionSelector value={this.state.section} onChange={section => this.setState({ section })} disabled={this.state.edit} />
						<SelectField
							floatingLabelText="Рубрика"
							value={category}
							errorText={(!category || category === '') && 'Рубрика необходима'}
							onChange={(event: any, index: number, newValue: string) => this.setState({ category: newValue })}
							disabled={this.state.edit}
						>
							{categories.edges
								.map(edge => edge.node)
								.map(cat => (
									<MenuItem key={cat.id} value={cat.id} primaryText={cat.name} />
								))}
						</SelectField>
						<TopicSelector viewer={this.props.viewer} value={this.state.topics} onChange={v => this.setState({ topics: v })} />
						<div className="button__bottom">
							<SelectField
								floatingLabelText="Статус публикации"
								value={this.state.state}
								onChange={(event, index, state) => this.onStateChanged(state)}
								disabled={this.state.edit}
							>
								<MenuItem value="available" primaryText="Опубликован" />
								<MenuItem value="draft" primaryText="Черновик" />
								<MenuItem value="deleted" primaryText="Удалено" />
							</SelectField>
							{this.state.spellCheckRequiredForPublish ? (
								<Checkbox
									title='Пропустить проверку орфографии для публикации'
									label={<small>Пропустить проверку</small>}
									checked={this.state.skipSpellCheckForPublish}
									onCheck={(e, checked) => this.setState({ skipSpellCheckForPublish: checked })}
									disabled={this.state.edit}
								/>
							) : null}
							<span
								title={
									this.state.spellCheckRequiredForPublish && !this.state.skipSpellCheckForPublish
										? 'Необходимо проверить орфографию (кнопка ниже или вкладка «Орфография»), либо отметьте пропуск проверки'
										: undefined
								}
								style={{ display: 'block' }}
							>
								<DefaultButton
									label="Сохранить"
									onClick={this.save}
									disabled={
										this.state.buttonDisableState ||
										(this.state.spellCheckRequiredForPublish && !this.state.skipSpellCheckForPublish)
									}
								/>
							</span>
							<RaisedButton
								label={this.state.spellCheckLoading ? 'Проверка…' : 'Проверить орфографию'}
								onClick={this.runSpellCheck}
								disabled={this.state.spellCheckLoading}
								style={{ ...styles.sidebar.button, marginTop: 8 }}
							/>
						</div>
						{viewer.me.canDelete && this.props.viewer.article !== null && this.state.state === 'deleted' && (
							<RaisedButton backgroundColor="red" label="Удалить из базы" onClick={this.remove} style={styles.sidebar.button} />
						)}
					</div>
				</div>
			</div>
		);
	}
}

const articleEditFieldsFragment = graphql`
	fragment Article_editFieldsFragment on Article {
		id
		title
		previewPicture
		foreignAgent
		previewAttribution
		body
		bodyHtml
		lead
		section
		category
		topics {
			id
			name
		}
		linkedArticles {
			id
			title
		}
		author
		hidden
		yaGenre
		isEvent
		infostring
		infostring_hot
		showInYandexNews
		showInYandexZen
		availableAt
		seoTitle
		seoDescription
		seoKeywords
		preview {
			id
			filename
			description
		}
		combinedPreviewVideo {
			id
			filename
			description
		}
		mediaFiles {
			id
		}
		state
		mainPageOrder
	}
`;

export default withAppContext(
	withRouter(
		createFragmentContainer(
			Article,
			graphql`
				fragment Article_viewer on Viewer @argumentDefinitions(id: { type: "ID!" }, section: { type: "ID!" }, blockSlug: { type: "String" }) {
					id
					article(id: $id) {
						...Article_editFieldsFragment @relay(mask: false)
						slug
						changes {
							userId
							userName
							modDate
						}
					}

					configurableBlock(slug: $blockSlug) {
						id
						type
						slug
						config
						active
					}

					persons(first: -1, personType: "author") {
						edges {
							node {
								id
								firstName
								lastName
							}
						}
					}

					categories(section: $section) {
						edges {
							node {
								id
								name
							}
						}
					}
					...TopicSelector_viewer
					...ArticleSelector_viewer
					me {
						id
						name
						email
						canDelete
					}
				}
			`,
		),
	),
);



// WEBPACK FOOTER //
// src/components/articles/Article.js